import { Check, SaveAlt } from "@material-ui/icons";
import {
  Box,
  Card,
  CircularProgress,
  Fab,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import Modal from "components/modal/Modal";
import Table from "components/table/Table";
import { downloadFileByS3Link } from "helper/common-helper";
import { usePagination } from "hooks/usePagination";
import InboundCallExportHistories from "pages/cloudPbx/inbound-call-v2/components/InboundCallExportHistories";
import OutboundCallExportHistories from "pages/cloudPbx/outbound-call/components/OutboundCallExportHistories";
import { useMemo } from "react";
import { useGetCallLogReports } from "service/query/report.query";
import muiTheme from "theme/muiTheme";

/** type = outboundCallLog, inboundCallLog*/
const ModalCallExportHistories = ({ type, open, onClose }) => {
  const { page, pageSize, handleChangePage, handleChangePageSize } =
    usePagination();

  const { data: callLogs, isLoading } = useGetCallLogReports(
    { type, page, size: pageSize },
    { enabled: !!type && open }
  );

  const columns = useMemo(
    () => [
      {
        id: "name",
        name: "Tên báo cáo",
      },
      {
        id: "type",
        name: "Loại báo cáo",
        render: (record) => (
          <>
            {record.type === "inboundCallLog" && "Gọi vào"}
            {record.type === "outboundCallLog" && "Gọi ra"}
          </>
        ),
      },
      {
        id: "status",
        name: "Trạng thái",
        render: (record) => (
          <Box
            display="flex"
            alignItems="center"
            minHeight={40}
            gap={1}
            textTransform="capitalize">
            <span>{record.status}</span>
            {record.status === "done" && (
              <Box color="green">
                <Check fontSize="small" />
              </Box>
            )}
            {record.status === "waiting" && <CircularProgress size={16} />}
          </Box>
        ),
      },
      {
        id: "creatorUsername",
        name: "Người tạo",
        render: (record) => record?.creator?.username,
      },
      {
        id: "createdAt",
        name: "Thời gian tạo",
        type: "datetime",
      },
      {
        id: "filter",
        name: "Bộ lọc",
        render: (record) => {
          return (
            <>
              {type === "inboundCallLog" && (
                <InboundCallExportHistories record={record} />
              )}
              {type === "outboundCallLog" && (
                <OutboundCallExportHistories record={record} />
              )}
            </>
          );
        },
      },
      {
        id: "download",
        name: "",
        align: "center",
        width: 100,
        render: (record) =>
          record.S3Url && (
            <Tooltip title="Tải xuống">
              <Fab
                color="primary"
                size="small"
                aria-label="export"
                onClick={() => downloadFileByS3Link(record.S3Url)}>
                <SaveAlt />
              </Fab>
            </Tooltip>
          ),
      },
    ],
    [type]
  );

  return (
    <ThemeProvider theme={muiTheme}>
      <Modal
        open={open}
        onClose={onClose}
        title="Lịch sử xuất báo cáo"
        maxWidth="xl">
        <Card sx={{ mb: 1 }}>
          <Table
            columns={columns}
            data={callLogs?.docs}
            loading={isLoading}
            pagination={{
              page,
              pageSize,
              totalItems: callLogs?.total,
              onPageChange: handleChangePage,
              onPageSizeChange: handleChangePageSize,
            }}
          />
        </Card>
      </Modal>
    </ThemeProvider>
  );
};

export default ModalCallExportHistories;
